import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../api';

const NotificationInfoPanel = ({ notification, onClose }) => {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [paketData, setPaketData] = useState(null);
  const [integrationData, setIntegrationData] = useState(null);

  const getStatusText = () => {
    if (notification.status === 'wait') return 'На модерации';
    if (notification.status === 'success') return 'Одобрено';
    if (notification.status === 'reject') return 'Отклонено';
    return 'Неизвестный статус';
  };

  const getPaketData = async () => {
    try {
      const responsePackege = await apiRequest(`/pakets?id=${notification.paket_id}`);
      // console.log(responsePackege.data);
      setPaketData(responsePackege.data);
      const integrationId = notification.integration_id || paketData.data.integration_id
      const responseIntegration = await apiRequest(`/integrations/${notification.rekl_id}/list?integration_id=${integrationId}`);
      console.log("responseIntegration.data: ", responseIntegration.data.integrations[0]);
      setIntegrationData(responseIntegration.data.integrations[0])
    } catch (error) {
      console.error('Ошибка при получении данных пакета:', error);
      setError(error.message || 'Ошибка при получении данных пакета');
    }
  };

  const getIntegrationData = async () => {
    try {
      const integrationId = notification.integration_id || paketData.data.integration_id
      const responseIntegration = await apiRequest(`/integrations/${notification.rekl_id}/list?integration_id=${integrationId}`);
      console.log("responseIntegration.data: ", responseIntegration.data.integrations[0]);
      setIntegrationData(responseIntegration.data.integrations[0])
    } catch (error) {
      console.error('Ошибка при получении данных интеграции:', error);
      setError(error.message || 'Ошибка при полу');
    }
  };

  useEffect(() => {
    if (notification?.paket_id) {
      getPaketData();
    } else if (notification?.integration_id) {
      getIntegrationData();
    }
  }, [notification?.paket_id, notification?.integration_id]);

  return (
    <div className="notification-info-panel" onClick={(e) => e.stopPropagation()}>
      <div className="notification-info-panel-header">
        <h3>Детали уведомления</h3>
        <button className="notification-info-panel-close" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="notification-info-panel-body">
        {error && (
          <div className="notification-error">
            {error}
          </div>
        )}
        <div className="notification-status">
          <span className={`status-badge status-${notification.status || 'wait'}`}>
            {getStatusText()}
          </span>
        </div>
        <div className="notification-text">
          {notification.notification_text}
        </div>
        <div className="notification-details">
          {integrationData && (
              <div className="notification-detail-item">
                <span className="detail-label">Интеграция:</span>
                <span className="detail-value">
                    {integrationData.name}
                  </span>
              </div>
          )}
          {paketData && (
              <div className="notification-detail-item">
                <span className="detail-label">Поток:</span>
                <span className="detail-value">
                    {paketData.flow_guide_name}
                  </span>
              </div>
          )}
          {paketData && (
              <div className="notification-detail-item">
                <span className="detail-label">Пакет:</span>
                <span className="detail-value">
                {paketData.paks_name || 'Неизвестно'}
              </span>
              </div>
          )}
          <div className="notification-detail-item">
            <span className="detail-label">Создано:</span>
            <span className="detail-value">
              {new Date(notification.created_at).toLocaleString('ru-RU')}
            </span>
          </div>
          <div className="notification-detail-item">
            <span className="detail-label">Изменено:</span>
            <span className="detail-value">
              {new Date(notification.updated_at).toLocaleString('ru-RU')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationInfoPanel;
